$( document ).ready(function() {

    $(document).on('click', '.coll-add-to-cart', function(e){  
        e.preventDefault();  

        $(this).addClass('btn--loading');
        var thisBtn1 = $(this)

        var ID = $(this).attr("data-variant-id");
            addItemToCart( ID, 1, thisBtn1);    // paste your id product number
          });

        function addItemToCart(variant_id, qty, thisBtn1) {

        data = {
            "id": variant_id,
            "quantity": qty
        }
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function(res) { 
            $(thisBtn1).removeClass('btn--loading');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    product: res,
                    addToCartBtn: thisBtn1
                }
            }));
            },
            error: function (request, status, error) {
            $(thisBtn1).removeClass('btn--loading');
            thisBtn1.after('<div class="errors text-center">' + request.responseJSON.description + '</div>');
            }   
            
        }); 
    }

    var options = {
        freeScroll: true,
        wrapAround: true,
        contain: true,
        groupCells: true,
        groupCells: 5,
        cellAlign: 'left',
        wrapAround: true,
        setGallerySize: true,
        imagesLoaded: true
      };
      
      
      if ( matchMedia('screen and (max-width: 480px)').matches ) {
        options.groupCells = 2;
      }
    
    $('.main-carousel').flickity(options);
});

// document.getElementById("jump_to_this_location").scrollIntoView({behavior: 'smooth'});